import * as React from 'react';

import AssignStudents from './assign_students';
import GradeLevelWarningModal from './gradeLevelWarningModal';
import NameTheUnit from './name_the_unit';
import OverrideWarningModal from './overrideWarningModal';
import ReviewActivities from './review_activities';
import SkipRecommendationsWarningModal from './skipRecommendationsWarningModal';

import { ButtonSpinner } from '../../../../../Shared/index'
;
import ScrollToTop from '../../../shared/scroll_to_top';
import { postTestClassAssignmentLockedMessages, } from '../../../../../Shared';
import AssignmentFlowNavigation from '../../assignment_flow_navigation';
import EvidenceGuardedButton from '../../../shared/evidenceGuardedButton';
import EvidenceRestrictedModal from '../../../shared/evidenceRestrictedModal';
import { AiRestrictionContext } from '../../../../contexts/AiRestrictionContextProvider';

export const EVIDENCE_RESTRICTED_ERROR_TYPE = 'evidence_restricted'

export class Stage2 extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      prematureAssignAttempted: false,
      loading: false,
      timesSubmitted: 0,
      showEvidenceRestrictedModal: false
    }
  }

  componentDidUpdate(prevProps) {
    const { createErrorType, } = this.props

    if (createErrorType && createErrorType !== prevProps.createErrorType) {
      this.setState({ loading: false, showEvidenceRestrictedModal: createErrorType === EVIDENCE_RESTRICTED_ERROR_TYPE, })
    }
  }

  static contextType = AiRestrictionContext

  assignButton() {
    const { loading, } = this.state
    const { selectedActivities, } = this.props
    return loading
      ? <button className={`${this.determineAssignButtonClass()} pull-right`} id="assign" type="button">Assigning... <ButtonSpinner variant="light" /></button>
      : <EvidenceGuardedButton activities={selectedActivities} className={`${this.determineAssignButtonClass()} pull-right`} onClick={this.handleClickAssign} withDemoGuard={true}>Assign pack to classes</EvidenceGuardedButton>;
  }

  determineAssignButtonClass() {
    let buttonClass = 'quill-button contained medium green focus-on-light';
    if (!this.buttonEnabled()) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  buttonEnabled() {
    const { areAnyStudentsSelected, selectedActivities, errorMessage } = this.props
    return areAnyStudentsSelected && selectedActivities.length && !errorMessage
  }

  selectedClassrooms() {
    const { classrooms, } = this.props

    return classrooms.filter(c => c.students.find(s => s.isSelected) || c.classroom.emptyClassroomSelected)
  }

  handleClickAssign = () => {
    const { timesSubmitted, } = this.state
    const { errorMessage, finish, reassignDiagnosticWarning, notYetCompletedPreTestStudentNames, showGradeLevelWarning, selectedActivities, } = this.props

    const selectedClassrooms = this.selectedClassrooms()
    const lowestSelectedClassroomGrade = Math.min(...selectedClassrooms.map(c => Number(c.classroom.grade) || 12))
    const aboveGradeLevelContentBeingAssigned = selectedActivities.find(a => {
      if (!a.minimum_grade_level) { return }

      return a.minimum_grade_level > lowestSelectedClassroomGrade
    })

    if (reassignDiagnosticWarning) {
      this.setState({ showOverrideWarningModal: true })
    } else if (notYetCompletedPreTestStudentNames.length) {
      this.setState({ showSkipRecommendationsWarningModal: true, })
    } else if (showGradeLevelWarning && aboveGradeLevelContentBeingAssigned) {
      this.setState({ showGradeLevelWarningModal: true, })
    } else if (this.buttonEnabled() && !errorMessage) {
      this.setState({ loading: true, });
      finish();
    } else {
      this.setState({ prematureAssignAttempted: true, timesSubmitted: timesSubmitted + 1 });
    }
  };

  onAssignDespiteWarning = () => {
    const { finish, } = this.props
    this.setState({ loading: true, });
    finish();
  }

  closeSkipRecommendationsWarningModal = () => {
    this.setState({ showSkipRecommendationsWarningModal: false, })
  }

  closeOverrideWarningModal = () => {
    this.setState({ showOverrideWarningModal: false, })
  }

  closeGradeLevelWarningModal = () => {
    this.setState({ showGradeLevelWarningModal: false, })
  }

  closeEvidenceRestrictedModal = () => {
    const { clearCreateError, } = this.props
    this.setState({ showEvidenceRestrictedModal: false, })
    clearCreateError?.()
  }

  renderEvidenceRestrictedModal() {
    const { showEvidenceRestrictedModal, } = this.state

    if (!showEvidenceRestrictedModal) { return }

    return (
      <EvidenceRestrictedModal
        aiRestrictedGroup={this.context}
        onClose={this.closeEvidenceRestrictedModal}
      />
    )
  }

  renderOverrideWarningModal() {
    const { showOverrideWarningModal, } = this.state
    const { reassignDiagnosticWarning, } = this.props

    if (!showOverrideWarningModal || !reassignDiagnosticWarning) { return }

    return (
      <OverrideWarningModal
        assignedStudentNames={reassignDiagnosticWarning.assignedStudentNames}
        diagnosticName={reassignDiagnosticWarning.diagnosticName}
        existingPacks={reassignDiagnosticWarning.existingPacks}
        handleClickAssign={this.onAssignDespiteWarning}
        handleCloseModal={this.closeOverrideWarningModal}
      />
    )
  }

  renderSkipRecommendationsWarningModal() {
    const { showSkipRecommendationsWarningModal, } = this.state
    const { notYetCompletedPreTestStudentNames, restrictedActivity, } = this.props

    if (!showSkipRecommendationsWarningModal) { return }

    return (
      <SkipRecommendationsWarningModal
        handleClickAssign={this.onAssignDespiteWarning}
        handleCloseModal={this.closeSkipRecommendationsWarningModal}
        restrictedActivityId={restrictedActivity.id}
        studentNames={notYetCompletedPreTestStudentNames}
      />
    )
  }

  renderGradeLevelWarningModal() {
    const { showGradeLevelWarningModal, } = this.state
    const { selectedActivities, } = this.props

    if (!showGradeLevelWarningModal) { return }

    return (
      <GradeLevelWarningModal
        handleClickAssign={this.onAssignDespiteWarning}
        handleCloseModal={this.closeGradeLevelWarningModal}
        selectedActivities={selectedActivities}
        selectedClassrooms={this.selectedClassrooms()}
      />
    )
  }

  renderAssignStudentsSection() {
    const {
      toggleClassroomSelection,
      toggleStudentSelection,
      user,
      classrooms,
      fetchClassrooms,
      lockedClassroomIds,
      restrictedActivity,
      cleverLink,
      googleLink,
    } = this.props

    return (
      <AssignStudents
        classrooms={classrooms}
        cleverLink={cleverLink}
        fetchClassrooms={fetchClassrooms}
        googleLink={googleLink}
        lockedClassroomIds={lockedClassroomIds}
        lockedMessage={restrictedActivity ? postTestClassAssignmentLockedMessages[restrictedActivity.id] : ''}
        toggleClassroomSelection={toggleClassroomSelection}
        toggleStudentSelection={toggleStudentSelection}
        user={user}
      />
    )
  }

  renderNameSection() {
    const { timesSubmitted, } = this.state
    const { errorMessage, unitName, updateUnitName, } = this.props
    return (
      <NameTheUnit
        nameError={errorMessage ? errorMessage.name : null}
        timesSubmitted={timesSubmitted}
        unitName={unitName}
        updateUnitName={updateUnitName}
      />
    )
  }

  renderReviewActivitiesSection() {
    const {
      selectedActivities,
      toggleActivitySelection,
      assignActivityDate,
      dueDates,
      publishDates,
    } = this.props
    return (
      <ReviewActivities
        activities={selectedActivities}
        assignActivityDate={assignActivityDate}
        dueDates={dueDates}
        publishDates={publishDates}
        toggleActivitySelection={toggleActivitySelection}
      />
    )
  }

  render() {
    const { unitTemplateName, unitTemplateId, isFromDiagnosticPath, } = this.props
    return (
      <div>
        {this.renderEvidenceRestrictedModal()}
        {this.renderGradeLevelWarningModal()}
        {this.renderOverrideWarningModal()}
        {this.renderSkipRecommendationsWarningModal()}
        <ScrollToTop />
        <AssignmentFlowNavigation
          button={this.assignButton()}
          isFromDiagnosticPath={isFromDiagnosticPath}
          unitTemplateId={unitTemplateId}
          unitTemplateName={unitTemplateName}
        />
        <main className="name-and-assign-activity-pack">
          <div className="container">
            <h1 className="assign-header">Review and Assign</h1>
            {this.renderNameSection()}
            {this.renderReviewActivitiesSection()}
            {this.renderAssignStudentsSection()}
          </div>
        </main>
      </div>
    );
  }
}

export default Stage2
